<template>
    <div>
        <div v-if="pleito">
            <b-row>
            <b-col sm="12" md="12" lg="12" xl="12">
                <b-card no-body>
                    <b-card-header>
                        <span class="h5">
                            PLEITO -
                            <strong>{{ pleito.nomeProponente }}</strong> -
                            <b-badge
                                variant="warning"
                                style="font-size: 12px"
                                >{{ pleito.numeroPleito }}</b-badge>
                            <div class="float-right">
                                <span v-if="pleito.status == 6">
                                    <b-button
                                        variant="success"
                                        @click.stop="aprovacaoGeralPleito()"
                                    >
                                        <i class="fa fa-check"></i> Aprovar o
                                        Pleito definitivamente
                                    </b-button>
                                </span>
                            </div>
                            <div class="float-right">
                                <span v-if="pleito.status == 6">
                                    <b-button
                                        variant="danger"
                                        @click.stop="reprovacaoGeralPleito()"
                                    >
                                        <i class="fa fa-ban"></i> Reprovar o
                                        Pleito definitivamente
                                    </b-button>
                                </span>
                            </div>
                            <div class="float-right">
                                <span v-if="pleito.status == 5">
                                    <b-button
                                        variant="success"
                                        @click.stop="
                                            verificarAdimplenciaProponente()
                                        "
                                    >
                                        <i class="fa fa-refresh"></i> Verificar
                                        Adimplência do Proponente
                                    </b-button>
                                </span>
                            </div>
                            <div class="float-right">
                                <span
                                    v-if="
                                        pleito.status == 4 || pleito.status == 6
                                    "
                                >
                                    <b-button
                                        variant="warning"
                                        @click.stop="emitirAtpDirex()"
                                    >
                                        <i class="fa fa-download"></i> Emitir
                                        ATP e Direx
                                    </b-button>
                                </span>
                            </div>
                            <div class="float-right">
                                <span v-if="pleito.status == 7">
                                    <b-button
                                        class="mr-2"
                                        variant="success"
                                        @click.stop="
                                            emitirDocumentacaoJuridica()
                                        "
                                    >
                                        <i class="fa fa-download"></i> Emitir
                                        Documentação Jurídica
                                    </b-button>
                                    <b-button
                                        variant="success"
                                        @click.stop="emitirPrevisaoFinanceira()"
                                    >
                                        <i class="fa fa-download"></i> Emitir
                                        Previsão Financeira
                                    </b-button>
                                </span>
                            </div>
                        </span>
                    </b-card-header>

                    <b-card-body>
                        <app-erros-box
                            :erros="erros"
                            v-if="erros.length > 0"
                        ></app-erros-box>

                        <b-tabs pills card vertical v-model="tabIndex">
                            <b-tab title="Dados Gerais" active class="pb-0">
                                <dados-gerais :pleito="pleito"></dados-gerais>
                            </b-tab>
                            <b-tab title="Metas" class="pb-0">
                                <pleito-metas
                                    :pleito="pleito"
                                    :pleitoAcoes="pleito.acoes"
                                    :dataServicos="dataServicos"
                                ></pleito-metas>
                            </b-tab>
                            <b-tab title="Despesas Sebrae" class="pb-0">
                                <pleito-despesas-sebrae
                                    :pleito="pleito"
                                    :pleitoDespesasSebrae="
                                        pleito.despesasSebrae
                                    "
                                    :dataServicos="dataServicos"
                                ></pleito-despesas-sebrae>
                            </b-tab>
                            <b-tab title="Despesas Parceiro" class="pb-0">
                                <pleito-despesas-parceiro
                                    :pleito="pleito"
                                    :pleitoDespesasParceiro="
                                        pleito.despesasParceiro
                                    "
                                    :dataServicos="dataServicos"
                                ></pleito-despesas-parceiro>
                            </b-tab>
                            <b-tab
                                title="Cronogramas de Desembolso Sebrae"
                                class="pb-0"
                            >
                                <pleito-cronogramas-desembolso-sebrae
                                    :pleito="pleito"
                                    :pleitoCronogramasDesembolsoSebrae="
                                        pleito.cronogramasDesembolsoSebrae
                                    "
                                    :dataServicos="dataServicos"
                                ></pleito-cronogramas-desembolso-sebrae>
                            </b-tab>
                            <b-tab
                                title="Cronogramas de Desembolso Parceiro"
                                class="pb-0"
                            >
                                <pleito-cronogramas-desembolso-parceiro
                                    :pleito="pleito"
                                    :pleitoCronogramasDesembolsoParceiro="
                                        pleito.cronogramasDesembolsoParceiro
                                    "
                                    :dataServicos="dataServicos"
                                ></pleito-cronogramas-desembolso-parceiro>
                            </b-tab>
                            <b-tab title="Cronogramas Físicos" class="pb-0">
                                <pleito-cronogramas-fisicos
                                    :pleito="pleito"
                                    :pleitoCronogramasFisicos="
                                        pleito.cronogramasFisicos
                                    "
                                    :dataServicos="dataServicos"
                                ></pleito-cronogramas-fisicos>
                            </b-tab>
                            <b-tab title="Conformidade Técnica" class="pb-0">
                                <conformidade-tecnica
                                    :pleito="pleito"
                                    :pleitoConformidadeTecnica="
                                        pleito.conformidadesTecnicas
                                    "
                                    :dataServicos="dataServicos"
                                    @atualizarConformidadeTecnica="obterPleito"
                                ></conformidade-tecnica>
                            </b-tab>
                            <b-tab title="Financeiro" class="pb-0">
                                <parecer-financeiro
                                    :pleito="pleito"
                                    :pleitoParecerFinanceiro="
                                        pleito.pareceresFinanceiros
                                    "
                                    :dataServicos="dataServicos"
                                    @atualizarParecerFinanceiro="obterPleito"
                                ></parecer-financeiro>
                            </b-tab>
                        </b-tabs>
                    </b-card-body>

                    <b-card-footer>
                        <b-button variant="danger" @click.stop="voltar()">
                            <span>
                                <i class="fa fa-history mr-2"></i> Voltar
                            </span>
                        </b-button>
                    </b-card-footer>
                </b-card>
            </b-col>
        </b-row>
        </div>
    
        <div v-else class="text-center p-4">
            
        </div>
    </div>
</template>

<script>
import DadosGerais from './PleitoDadosGerais'
import PleitoMetas from './metas/PleitoMetas'
import PleitoDespesasParceiro from './despesasparceiro/PleitoDespesasParceiro'
import PleitoDespesasSebrae from './despesassebrae/PleitoDespesasSebrae'
import PleitoCronogramasDesembolsoSebrae from './cronogramasdesembolsosebrae/PleitoCronogramasDesembolsoSebrae'
import PleitoCronogramasDesembolsoParceiro from './cronogramasdesembolsoparceiro/PleitoCronogramasDesembolsoParceiro'
import PleitoCronogramasFisicos from './cronogramasfisicos/PleitoCronogramasFisicos'
import ConformidadeTecnica from './conformidadetecnica/PleitoConformidadeTecnica'
import ParecerFinanceiro from './parecerfinanceiro/PleitoParecerFinanceiro'

export default {
    props: {
        dataServicos: {
            type: Object
        },

        rotaListagem: {
            type: String
        }
    },
    components: {
        DadosGerais,
        PleitoMetas,
        PleitoDespesasParceiro,
        PleitoDespesasSebrae,
        PleitoCronogramasDesembolsoSebrae,
        PleitoCronogramasDesembolsoParceiro,
        PleitoCronogramasFisicos,
        ConformidadeTecnica,
        ParecerFinanceiro
    },

    data() {
        return {
            pleito: null,
            tabIndex: 0,
            erros: []
        }
    },

    methods: {
        voltar() {
            this.$router.push({ name: this.rotaListagem })
        },

        obterPleito() {
            this.$store.dispatch('addRequest')
            this.dataServicos
                .obterPleitoPorId(this.$route.params.pleitoId)
                .then(response => {
                    if (response) {
                        if (response.success) {
                            this.pleito = response.data
                        } else {
                            this.erros = response.errors
                        }
                    }
                    this.$store.dispatch('removeRequest')
                })
        },

        verificarAdimplenciaProponente() {
            this.$store.dispatch('addRequest')
            this.dataServicos
                .verificarAdimplenciaProponente(this.$route.params.pleitoId)
                .then(response => {
                    if (response) {
                        if (response.success) {
                            this.obterPleito()
                        } else {
                            this.erros = response.errors
                        }
                    }
                    this.$store.dispatch('removeRequest')
                })
        },

        emitirAtpDirex() {
            this.$store.dispatch('addRequest')
            this.dataServicos
                .emitirAtpDirex(this.$route.params.pleitoId)
                .then(response => {
                    if (response) {
                        if (response.type === 'application/json') {
                            this.$toast.error(
                                'Erro no Download!!!',
                                'ERROR',
                                this.$toastConfig.error
                            )
                        } else {
                            this.$download(response, 'ATP_DIREX.pdf')
                            this.obterPleito()
                        }
                    }
                    this.$store.dispatch('removeRequest')
                })
        },

        emitirDocumentacaoJuridica() {
            this.$store.dispatch('addRequest')
            this.dataServicos
                .emitirDocumentacaoJuridica(this.$route.params.pleitoId)
                .then(response => {
                    if (response) {
                        if (response.type === 'application/json') {
                            this.$toast.error(
                                'Erro no Download!!!',
                                'ERROR',
                                this.$toastConfig.error
                            )
                        } else {
                            this.$download(
                                response,
                                'DOCUMENTACAO-JURIDICA.pdf'
                            )
                            this.obterPleito()
                        }
                    }
                    this.$store.dispatch('removeRequest')
                })
        },

        emitirPrevisaoFinanceira() {
            this.$store.dispatch('addRequest')
            this.dataServicos
                .emitirPrevisaoFinanceira(this.$route.params.pleitoId)
                .then(response => {
                    if (response) {
                        if (response.type === 'application/json') {
                            this.$toast.error(
                                'Erro no Download!!!',
                                'ERROR',
                                this.$toastConfig.error
                            )
                        } else {
                            this.$download(response, 'PREVISÃO FINANCEIRA.pdf')
                            this.obterPleito()
                        }
                    }
                    this.$store.dispatch('removeRequest')
                })
        },

        aprovacaoGeralPleito() {
            this.$store.dispatch('addRequest')
            this.dataServicos
                .aprovacaoGeralPleito(this.$route.params.pleitoId)
                .then(response => {
                    if (response) {
                        if (response.success) {
                            this.obterPleito()
                        } else {
                            this.erros = response.errors
                        }
                    }
                    this.$store.dispatch('removeRequest')
                })
        },

        reprovacaoGeralPleito() {
            this.$store.dispatch('addRequest')
            this.dataServicos
                .reprovacaoGeralPleito(this.$route.params.pleitoId)
                .then(response => {
                    if (response) {
                        if (response.success) {
                            this.obterPleito()
                        } else {
                            this.erros = response.errors
                        }
                    }
                    this.$store.dispatch('removeRequest')
                })
        }
    },

    created() {
        this.obterPleito()
    }
}
</script>
